import React from "react"

const Tip = ({ number, title, description }) => {
    return (
        <div 
        data-sal="slide-up"
        data-sal-duration="1000"
        data-sal-easing="ease" className="tip">
            <h1 className="tip-number">{number}</h1>
            <h3 className="tip-title" >{title}</h3>
            <p className="tip-description">{description}</p>
        </div>
    )
}

export default Tip